import { render, staticRenderFns } from "./COSOC.vue?vue&type=template&id=6480d0c4&scoped=true&"
import script from "./COSOC.vue?vue&type=script&lang=ts&"
export * from "./COSOC.vue?vue&type=script&lang=ts&"
import style0 from "./COSOC.vue?vue&type=style&index=0&id=6480d0c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6480d0c4",
  null
  
)

export default component.exports